"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CURRENCY_CODES = exports.CAR_SPEC_OTHER = exports.CAR_SPEC_MAIN = void 0;
var CAR_SPEC_MAIN = 'main';
exports.CAR_SPEC_MAIN = CAR_SPEC_MAIN;
var CAR_SPEC_OTHER = 'other';
exports.CAR_SPEC_OTHER = CAR_SPEC_OTHER;
var CURRENCY_CODES = {
    RUB: '₽',
    BYN: 'Br',
    KZT: '₸',
    KGS: 'с',
};
exports.CURRENCY_CODES = CURRENCY_CODES;
